<template>
    <div class="column-layout">
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="doExport">导出贴码</div>
            </div>
        </div>
        <div class="table-layout">
            <div name="asset-single" v-if="tableState != null && tableState.length > 0">
                <div class="tab-container small base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li :class="{'current': status.value == checkTapValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">
                                <span>{{status.text}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <el-table :data="dataList" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" :selectable="selectable" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column prop="no" label="套装系统编号" align="center" width="200"></el-table-column>
                <el-table-column prop="name" label="套装名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="retailerShopName" label="所属机构" width="200" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcQuantity" label="套内资产数量" width="100" align="right" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ts" label="最新套装变更时间" width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="100" label="主资产图片">
                    <template slot-scope="rows">
                        <img :src="rows.row.imageUrl" v-if="rows.row.imageUrl != null && rows.row.imageUrl!=''">
                    </template>
                </el-table-column>
                <el-table-column prop="devcTitle" label="主资产名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcTmpNo" label="主资产系统编号" width="250" align="left" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span><a class="swb-btn-link" @click.stop="toShopDeviceList(rows.row.devcTmpNo)">{{rows.row.devcTmpNo}}</a></span>
                    </template>
                </el-table-column>
                <el-table-column prop="devcCatName" label="主资产分类" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcGroup" label="主资产分类分组" width="150" align="left" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{getDevcGroupNameByCatId(rows.row.devcCatId)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="devcBrandName" label="主资产品牌" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcModelSpec" label="主资产规格" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="departName" label="主资产责任部门" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="principalName" label="主资产责任人" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="id" label="操作" align="left" width="100" fixed="right">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" @click="viewDetail(rows.row.id)">查看</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import appConf from '../../app.conf';
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm, getDevcGroupNameByCatId } from '../index'
    import { setAssetsGroupDevcFilter } from '../asset/selectDlg'

    import devcApi from '../../api/devc'
    import userApi from '../../api/user';

    import SwbShopDeviceSuitDetail from './ShopDeviceSuitDetail';
    Vue.regist(SwbShopDeviceSuitDetail);
    import SwbShopDeviceList from '../devc/ShopDeviceList';
    Vue.regist(SwbShopDeviceList);

    let mockConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "套装系统编号",
            "code": "no",
            "dataLabel": "text",
            "dataValue": "code",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "套装名称",
            "code": "name",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "code": "retailerShopName",
            "label": "所属机构",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "主资产名称",
            "code": "devcTitle",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "code": "devcTmpNo",
            "label": "主资产系统编号",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "主资产分类",
            "code": "devcCatName"
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "主资产品牌",
            "code": "devcBrandName"
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "主资产规格",
            "code": "devcModelSpec"
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-shop-device-suit-list-for-select',
        desc: '资产套装列表-选择',
        props: {
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            selectTmpNos: {
                type: Array,
                default: null
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: [],
                treeCollapse: true,
                thisComId: null,
                includeSubComs: false,
                devcWarehouseId: null,
                exportParmas: null,
                multipleSelection: [],
                includeItems: false,
                selectTmpNoMap: {},
                servcType: null,
                beyondWrnt: null,
                servicerId: null,
                devcGroupId: null,
                fiscalAcctFlag: null,
                //
                inspectFlag: false,
                relFlag: false,     // 是否关联子设备查询
                inspectFlowFlag: false,
                inspectFlowId: null,
                // 页签
                tableState: [{
                    text: "默认可用资产",
                    value: 0
                }, {
                    text: '全部',
                    value: 1
                }],
                checkTapValue: 0,
            }
        },
        created: function () {
            let filter = this.filter;
            this.thisComId = filter.thisComId;
            this.includeSubComs = filter.includeSubComs;
            this.locked = filter.locked;
            this.servcType = filter.servcType;
            this.fiscalAcctFlag = filter.fiscalAcctFlag;
            this.beyondWrnt = Utils.isNoB(filter.beyondWrnt) ? null : filter.beyondWrnt;
            this.relFlag = filter.relFlag;
            if(!Utils.isNoB(filter.includeItems)) {
                this.includeItems = filter.includeItems;
            }
            if(!Utils.isNoB(filter.devcWarehouseId)) {
                this.devcWarehouseId = filter.devcWarehouseId;
            }
            if(Utils.isTrue(filter.inspectFlag)) {
                this.inspectFlag = filter.inspectFlag;
                this.inspectFlowFlag = filter.inspectFlowFlag;
                this.inspectFlowId = filter.inspectFlowId;
            }
            // 页签设置[服务商不为空时： 显示【默认可用资产】【全部】页签]，保养选择套装【默认可用资产】根据分类分组+服务商过滤主套装，【全部】即相对条件下的所有套装
            this.devcGroupId = filter.devcGroupId;
            if(Utils.isNoB(filter.servicerId)) {
                this.tableState = [];
                this.checkTapValue = null;
            } else {
                this.servicerId = filter.servicerId;
            }
            //
            let selectTmpNos = this.selectTmpNos;
            if(selectTmpNos != null && selectTmpNos.length > 0) {
                let selectTmpNoMap = {};
                for(let i = 0, length = selectTmpNos.length; i < length; i++) {
                    let selectTmpNo = selectTmpNos[i];
                    selectTmpNoMap[selectTmpNo] = selectTmpNo;
                }
                this.selectTmpNoMap = selectTmpNoMap;
            }
            //
            let self = this;
            setAssetsGroupDevcFilter(mockConfigData, function (callbackQueryConfig) {
                //
                self.queryConfig = Utils.merge({}, callbackQueryConfig);
            });
            //
            this.pageSize = this.pageSizes.first();
            this.getDataList();
        },
        methods: {
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            selectable: function (row, index) {
                return Utils.isNoB(this.selectTmpNoMap[row.devcTmpNo]);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getDataList();
            },
            // 页签切换
            handleTabClick: function (val) {
                if(val != this.checkTapValue) {
                    this.checkTapValue = val;
                    if(val == 0) {
                        // 默认可用资产： 根据 服务商 过滤主资产
                        this.servicerId = this.filter.servicerId;
                    } else {
                        this.servicerId = null;
                    }
                    this.getDataList();
                }
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(self.thisComId)) {
                    filterItems.retailerShopId = self.thisComId;
                }
                if(!Utils.isNoB(self.includeSubComs)) {
                    filterItems.includeSubComs = self.includeSubComs;
                }
                if(!Utils.isNoB(self.devcWarehouseId)) {
                    filterItems.devcWarehouseId = self.devcWarehouseId;
                }
                if(!Utils.isNoB(self.includeItems)) {
                    filterItems.includeItems = self.includeItems;
                }
                if(!Utils.isNoB(self.servcType)) {
                    filterItems.servcType = self.servcType;
                }
                if(!Utils.isNoB(self.beyondWrnt)) {
                    filterItems.beyondWrnt = self.beyondWrnt;
                }
                if(!Utils.isNoB(self.servicerId)) {
                    filterItems.servicerId = self.servicerId;
                }
                if(!Utils.isNoB(self.devcGroupId)) {
                    filterItems.devcGroupId = self.devcGroupId;
                }
                if(!Utils.isNoB(self.fiscalAcctFlag)) {
                    filterItems.fiscalAcctFlag = self.fiscalAcctFlag;
                }
                if(!Utils.isNoB(self.locked)) {
                    filterItems.locked = self.locked;
                }
                if(!Utils.isNoB(self.relFlag)) {
                    filterItems.relFlag = self.relFlag;
                }
                if(Utils.isTrue(self.inspectFlag)) {
                    filterItems.inspectFlag = self.inspectFlag;
                    filterItems.inspectFlowFlag = self.inspectFlowFlag;
                    filterItems.inspectFlowId = self.inspectFlowId;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                self.exportParmas = filterItems;
                //
                let theLoading = MsgBox.loading();
                devcApi.getShopDeviceSuitPaginatedList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.dataList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看详情
            viewDetail(id){
                let self = this;
                Vue.$showDialog({
                    title: "资产套装详情",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-suit-detail :id="id" :toShopDeviceList="toShopDeviceList"></swb-shop-device-suit-detail>' +
                    '</div>',
                    data: {
                        id: id
                    },
                    methods: {
                        toShopDeviceList: function (no) {
                            self.toShopDeviceList(no);
                        },
                    },
                });
            },
            toShopDeviceList(no) {
                let data = {
                    tmpNo: no
                };
                let hashUrl = Utils.makeUrl(SwbShopDeviceList.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            doExport(){
                let self = this;
                //
                let multipleSelection = this.multipleSelection;
                if(multipleSelection.length == 0) {
                    //
                    let postData = self.exportParmas;
                    devcApi.saveSuitParamsForExport(postData, function (result) {
                        if(result.type == 'info') {
                            self.showTheExportDlg(null, result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let postData = [];
                    multipleSelection.forEach(function (el) {
                        postData.push({
                            name: el.name,
                            no: el.no,
                            devcCatName: el.devcCatName,
                            devcBrandName: el.devcBrandName
                        });
                    });
                    //
                    devcApi.saveSuitModelForExport(postData, function (result) {
                        if(result.type == 'info') {
                            self.showTheExportDlg(result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            showTheExportDlg(dataUuid = null, paramsUuid = null) {
                let theDlg = Vue.$showDialog({
                    title: '确定设备贴码文件格式 - 导出' + (dataUuid ? '选中的设备' : ''),
                    showCloseBtn: true,
                    width: 800,
                    height: 500,
                    template: '<div>' +
                    '<div class="hint block" v-if="isShowMessage">' +
                    '   <p>{{message}}</p>' +
                    '</div>' +
                    '<div class="simple-form">' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >分组方式</label>' +
                    '        </div>' +
                    '        <div class="form-value  width-2x">' +
                    '            <el-radio-group v-model="group">' +
                    '                <el-radio v-for="dataItem in groupTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >模版类型</label>' +
                    '        </div>' +
                    '        <div class="form-value width-2x">' +
                    '            <el-radio-group v-model="modelType" @change="modelTypeChange">' +
                    '                <el-radio v-for="dataItem in allModelTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >模版尺寸</label>' +
                    '        </div>' +
                    '        <div class="form-value width-2x radio">' +
                    '            <el-radio-group v-model="size">' +
                    '                <el-radio v-for="dataItem in allSizes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >纸张尺寸</label>' +
                    '        </div>' +
                    '        <div class="form-value width-2x">' +
                    '            <el-radio-group v-model="paper">' +
                    '                <el-radio v-for="dataItem in allPaper" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '    <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >文件格式</label>' +
                    '        </div>' +
                    '        <div class="form-value width-2x">' +
                    '            <el-radio-group v-model="format">' +
                    '                <el-radio v-for="dataItem in allFormats" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '    <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >文件名称</label>' +
                    '        </div>' +
                    '        <div class="form-value width-2x">' +
                    '           <el-input v-model="fileName" title="导出文件名称，可选填，默认为 【所属机构名称】-设备服务号（注意：不要带文件扩展名）"></el-input>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        groupTypes: [{value: 'cat', text: '设备分类'}, {value: 'cat brand', text: '设备分类 + 品牌'}],
                        allModelTypes: [{value: 'standard', text: '标准码'}, {value: 'nonstandard', text: '非标准码'}],
                        allFormats: [{value: 'pdf', text: 'pdf'}, {value: 'docx', text: 'docx'}],
                        allSizes: [],
                        standardSizes: [
                            {value: 'small', text: '小标签(24mm*24mm)'},
                            {value: 'middle', text: '中标签(36mm*36mm)'},
                            {value: 'shoppingCart', text: '购物车标签1(16mm*16mm)'},
                            {value: 'squareLarge', text: '方形大标签(90mm*90mm)'}
                        ],
                        nonstandardSizes: [
                            {value: 'small', text: '小标签(24mm*60mm)'},
                            {value: 'middle', text: '中标签(36mm*80mm)'},
                            {value: 'shoppingCart', text: '购物车标签1(16mm*16mm)'},
                            {value: 'squareSmall', text: '方形小标签(24mm*24mm)'},
                            {value: 'squareLarge', text: '方形大标签(90mm*90mm)'}
                        ],
                        allPaper: [{value: 'A4', text: 'A4'}, {value: '100mm', text: '100mm'}],
                        group: 'cat',
                        format: 'pdf',
                        modelType: 'standard',
                        size: 'small',
                        paper: 'A4',
                        fileName: '',
                        message: '注意: 请在1分钟内完成导出操作（防止数据过期）',
                        isShowMessage: false
                    },
                    methods: {
                        modelTypeChange(){
                            if(this.modelType == 'standard') {
                                this.allSizes = this.standardSizes;
                            } else {
                                this.allSizes = this.nonstandardSizes;
                            }
                            this.size = this.allSizes[0].value;
                        }
                    },
                    okClicked: function () {
                        let theDownloadUrl = Utils.makeUrl(getAppUrl('/shop/devc/suit/stick/qrcode/file/jsp'), {
                            group: this.group,
                            format: this.format,
                            modelType: this.modelType,
                            size: this.size,
                            paper: this.paper,
                            fileName: this.fileName,
                            dataUuid: dataUuid || null,
                            paramsUuid: paramsUuid || null
                        });
                        Utils.setPageUrl(theDownloadUrl, '_blank');
                        //
                        return true;
                    },

                    lifecycle: {
                        created: function () {
                            this.isShowMessage = true;
                            this.allSizes = this.standardSizes;
                        }
                    }
                });
            },
            //
            getDlgResult(){
                let result = {};
                let multipleSelection = this.multipleSelection;
                if(multipleSelection != null && multipleSelection.length > 0) {
                    result.type = "info";
                    result.data = multipleSelection;
                } else {
                    result.type = "wran";
                    result.message = "请选择设备套装";
                }
                return result;
            }
        }
    }
</script>
<style>
    .form-value.radio .el-radio + .el-radio {
        margin-left: 0;
    }

    .form-value.radio {
        width: calc(100% - 126px - 20px);
        width: -webkit-calc(100% - 126px - 20px);
        width: -moz-calc(100% - 126px - 20px);
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSuitListForSelect.vue